import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M6.458 3.958h7.084v5.209a3.542 3.542 0 0 1-7.084 0V3.958Zm7.292 1.667h.086a2.205 2.205 0 0 1 .754 4.278l-.84.305m-7.5-4.583h-.086a2.205 2.205 0 0 0-.754 4.278l.84.305M10 12.917v2.916m-2.708.209h5.416" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);